module.exports = __webpack_public_path__ + "static/img/news-album.5d3fa14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-album.png
// module id = ND1T
// module chunks = 1